import { Outlet, RouteObject } from '@rocketlane/rocket-router';
import { FC, PropsWithChildren } from 'react';
import { Settings } from 'components/pages/settings';
import { BlacklistedDomainsPage } from 'components/pages/settings/emails/blacklisted-domains';
import { EmailFieldsPage } from 'components/pages/settings/emails/email-fields';
import { EmailIntelligencePage } from 'components/pages/settings/emails/email-intelligence';
import { MeetingFieldsPage } from 'components/pages/settings/meeting-fields/page';
import { SignalConfigurationListPage } from 'components/pages/settings/signal-configuration/list/page';
import { SignalFieldsPage } from 'components/pages/settings/signal-fields/page';
import { knowledgeBaseRoutes } from './knowledge-base';
import { ROUTE_PATHS } from './route-paths';
import { salesforceRoutes } from './salesforce-routes';
import { SecureRoute } from './secure-route';

const SettingLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <SecureRoute>
      <Settings>{children}</Settings>
    </SecureRoute>
  );
};

export const settingsRoutes: RouteObject = {
  path: ROUTE_PATHS.SETTINGS,
  element: <Outlet />,
  children: [
    {
      path: ROUTE_PATHS.SETTINGS_SIGNAL_FIELDS,
      element: (
        <SettingLayout>
          <SignalFieldsPage />
        </SettingLayout>
      ),
    },
    {
      path: ROUTE_PATHS.SETTINGS_MEETING_FIELDS,
      element: (
        <SettingLayout>
          <MeetingFieldsPage />
        </SettingLayout>
      ),
    },
    {
      path: ROUTE_PATHS.SETTINGS_EMAIL_FIELDS,
      element: (
        <SettingLayout>
          <EmailFieldsPage />
        </SettingLayout>
      ),
    },
    {
      path: ROUTE_PATHS.SETTINGS_EMAIL_BLACKLIST,
      element: (
        <SettingLayout>
          <BlacklistedDomainsPage />
        </SettingLayout>
      ),
    },
    {
      path: ROUTE_PATHS.SETTINGS_EMAIL_INTELLIGENCE,
      element: (
        <SettingLayout>
          <EmailIntelligencePage isModuleFed={false} />
        </SettingLayout>
      ),
    },
    {
      path: ROUTE_PATHS.SETTINGS_SIGNAL_CONFIGURATION_LIST,
      element: (
        <SettingLayout>
          <SignalConfigurationListPage />
        </SettingLayout>
      ),
    },
    knowledgeBaseRoutes,
    salesforceRoutes,
  ],
};
